// extracted by css-extract-rspack-plugin
export default {"table":"z0EYAVhkr1ARbWKS"};